import createIcon from '../createIcon';

export const OtherDeviceIcon = createIcon({
  path: (
    <path
      d="M8 12H44V8H8C5.8 8 4 9.8 4 12V34H0V40H28V34H8V12ZM46 16H34C32.9 16 32 16.9 32 18V38C32 39.1 32.9 40 34 40H46C47.1 40 48 39.1 48 38V18C48 16.9 47.1 16 46 16ZM44 34H36V20H44V34Z"
      fill="currentColor"
    />
  ),
});
